import TeacherSelector from './teacher-selector.vue';
import TeacherCheckingSelector from './teacher-checking-selector.vue';

export default {
  install(application) {
    application.component('yx-teacher-selector', TeacherSelector);
    application.component('teacher-checking-selector', TeacherCheckingSelector);
  },
};
